// Assessment route (/$region/assessments/$assessmentUid): the open topic and the result filters as typed search params (defaults stripped), the detail and result rows loaded ahead for Confidential users, and the screen AssessmentPage.
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";

import { canAccess } from "@/app/nav";
import { meQueryOptions } from "@/app/session";
import { AssessmentPage } from "@/features/assessments/assessment/AssessmentPage";
import { assessmentSearchDefaults, assessmentSearchSchema } from "@/features/assessments/assessment/filters";
import { detailOptions, resultsOptions } from "@/features/assessments/assessment/queries";

export const Route = createFileRoute("/_app/$region/assessments/$assessmentUid")({
  validateSearch: assessmentSearchSchema,
  search: { middlewares: [stripSearchParams(assessmentSearchDefaults)] },
  staticData: { crumb: "Assessment" },
  loader: async ({ context, params }) => {
    const me = context.queryClient.getQueryData(meQueryOptions().queryKey);
    if (me === undefined || !canAccess(me.roles, "C")) {
      return;
    }
    await Promise.allSettled([
      context.queryClient.query({ ...detailOptions(params.assessmentUid), staleTime: "static" }),
      context.queryClient.query({ ...resultsOptions(params.assessmentUid), staleTime: "static" }),
    ]);
  },
  component: AssessmentRoute,
});

function AssessmentRoute() {
  const { assessmentUid } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AssessmentPage
      assessmentUid={assessmentUid}
      search={search}
      onSearchChange={(patch, options) => {
        void navigate({
          search: (previous) => ({ ...previous, ...patch }),
          replace: options?.replace ?? false,
        });
      }}
    />
  );
}
